import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { API_ADDRESS } from '../../constants';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable()
export class IntelliDataSelectorService {



    constructor(@Inject(LOCALE_ID) private locale: string, private http: HttpClient) { }



    public getItemForIntelliDataSelector(id: number, controllerName: string, methodName: string,
        startOptions: any[] ): Promise<any> {


        let startListObject = startOptions.find(x=>x.id==id);
      
        if(startListObject!=null)
        {

 
            return new Promise<any>(resolve=>
            {
                resolve(startListObject);
            });
        }

        if (id == null) {
            id = 0;
        }
        if (methodName == null || methodName == "") {
            methodName = "getItemForIntelliDataSelector"
        }
       return this.http.get(API_ADDRESS + `/${controllerName}/${methodName}/${id}`)
        .pipe(
            map((result: any) => {
                //   console.log(result);
                return result;
            })).toPromise();
    }


    public geListForIntelliDataSelector(startPos: number, length: number, searchText: string, controllerName: string,
        methodName: string,
        startOptions: any[] ): Observable<any[]> {

        if (methodName == null || methodName == "") {
            methodName = "getListForIntelliDataSelector"
        }

        return this.http.get(API_ADDRESS + `/${controllerName}/${methodName}/${startPos}/${length}/${btoa(searchText)}`)
        .pipe(
            map((result: any) => {
                let data = result;

                startOptions.forEach(a => {
                    data.push(a);
                });

       

                return data;
            }));

    }



}
